import { getConfig } from "./config.js";
import { Elm } from "./Main.elm";

function getQRHash() {
  const match = window.location.pathname.match(/^\/qr\/([^\/]+)$/);
  return match ? match[1] : null;
}

const app = Elm.Main.init({
  node: document.getElementById("elm-app"),
  flags: {
    backendUrl: getConfig()["backend-url"],
    serviceUrl: getConfig()["services-url"],
    qrSessionId: getQRHash(),
  },
});

// Set up ports

document.onSignIn = function (googleUser) {
  var profile = googleUser.getBasicProfile();
  var token = googleUser.getAuthResponse().id_token;
  app.ports.toElm.send(token);
};

// Handle redirect to login
app.ports.redirectToLogin.subscribe(function (loginUrl) {
  window.location.href = loginUrl;
});

// Handle getting current URL
app.ports.getCurrentUrl.subscribe(function () {
  app.ports.receiveCurrentUrl.send(window.location.href);
});
